export const SECTION_NAMES = {
  HOME: "home",
  ARTISTS: "artists",
  PROGRAM: "program",
  TICKETS: "tickets",
  PARTNERS: "partners",
}
